/**
     * @desc 重新加载我的NFT
重新检查钱包中的NFT，并将新获得的NFT加入Tspace
     */

import * as defs from '../../baseClass';
import { PontCore } from '../../pontCore';
import * as ajax from '../../../utils/request';

export class Params {}

export const init = new defs.Result();

export function request(params, options = {}) {
  return ajax.post('/item/refreshMyNFT', params);
}

export function upload(params, options = {}) {
  return ajax.upload('/item/refreshMyNFT', params);
}
